import { render, staticRenderFns } from "./page-reports-download-link.vue?vue&type=template&id=2baa17ce&"
import script from "./page-reports-download-link.vue?vue&type=script&lang=js&"
export * from "./page-reports-download-link.vue?vue&type=script&lang=js&"
import style0 from "./page-reports-download-link.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../tmp/ffsecurity-ui/node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports